import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

export interface ServerErrorPageProps {
  onRetry?: () => void;
}

export function ServerErrorPage({ onRetry }: ServerErrorPageProps) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      gap={1.5}
      px={2}
      textAlign="center"
    >
      <Typography variant="h2" fontWeight={700} color="error.main">
        500
      </Typography>
      <Typography variant="h6">Something went wrong</Typography>
      <Typography variant="body2" color="text.secondary" maxWidth={360}>
        An unexpected error occurred while rendering this page. Try again, and contact support if the problem persists.
      </Typography>
      <Button
        variant="contained"
        sx={{ mt: 2 }}
        onClick={() => {
          if (onRetry) {
            onRetry();
          } else {
            window.location.assign('/dashboard');
          }
        }}
      >
        {onRetry ? 'Try again' : 'Back to dashboard'}
      </Button>
    </Box>
  );
}
